/**
 * Propeller Pro v1.0.0 (https://pro.propeller.in/)
 * Copyright 2016-2018 Digicorp Information Systems Pvt. Ltd.
 * License: GNU General Public License v2.0 or later
 * License URI: http://www.gnu.org/licenses/gpl-2.0.html
 */

import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms'
import { PmdEditorComponent } from './text-editor.component';
import { PmdButtonModule } from '../propeller/button/button.module';
import { PmdTooltipModule } from '../propeller/tooltip/tooltip.module';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PmdButtonModule,
    PmdTooltipModule,
    NgSelectModule
  ],
  declarations: [
	  PmdEditorComponent,
  ],
  exports: [
	  PmdEditorComponent,
    PmdButtonModule,
    PmdTooltipModule
  ]
})
export class PmdEditorModule {
  static forRoot(): ModuleWithProviders<PmdEditorModule> {
    return { ngModule: PmdEditorModule };
  }
}
